@if (multiple && result !== null && isResultAnArray(result) && result.length) {
  <!--suppress TypeScriptValidateTypes -->
  <!-- By index for the same reason as the option list below: the values can repeat. -->
  @for (res of result; track $index; let index = $index) {
    <div class="result-element">
      <ng-container [ngTemplateOutletContext]="{option: res, index}"
      [ngTemplateOutlet]="tagTemplate || defaultTagTemplate"></ng-container>
      @if (!disabled) {
        <i (click)="removeFromResult(index)" class="material-icons remove-result">remove</i>
      }
    </div>
  }
}

@if ((multiple && showControls) || inputVisible) {
  <div class="controls">
    @if (multiple && showControls && !inputVisible) {
      <i (click)="inputVisible = true"
      class="control material-icons">add</i>
    }
    @if (inputVisible) {
      <div class="autocomplete-text-input" cdkOverlayOrigin #panelTrigger="cdkOverlayOrigin">
        <input #textInput [formControl]="input" [placeholder]="placeholder || ''" tabindex="0" type="text">
        <i (click)="toggleList(textInput)" [class.disabled]="!HasOptions"
        class="material-icons">{{ Open ? 'expand_less' : 'expand_more' }}</i>
        <!-- No backdrop: the field stays typeable while the list is open, so dismissal is left to
             the document listener in the component (which also ignores clicks inside the panel). -->
        <ng-template cdkConnectedOverlay appOverlayPanel matchTriggerWidth [backdrop]="false"
          [cdkConnectedOverlayOrigin]="panelTrigger"
          [cdkConnectedOverlayOpen]="Open"
          [panelPositions]="positions"
          (panelClose)="Open = false">
          <ul class="autocomplete-list">
            @if (displayedOptions.length === 0 && input.value !== '') {
              <li>
                <span class="red" i18n>
        No results for „{{ input.value }}”
      </span>
              </li>
            }
            <!-- Tracked by index, not value: these are plain strings straight from the backend (and,
                 here, whatever the user typed), so the same one can appear twice — duplicate track
                 keys are NG0955. -->
            @for (option of displayedOptions; track $index; let index = $index) {
              <li (click)="selectOption(option)">
                <ng-container [ngTemplateOutletContext]="{option, index}"
                [ngTemplateOutlet]="listElementTemplate || defaultListElementTemplate"></ng-container>
                @if (multiple) {
                  @if (!this.result?.includes(option)) {
                    <i
                    class="material-icons">add</i>
                  } @else {
                    <i class="material-icons green">done</i>
                  }
                }
              </li>
            }
          </ul>
        </ng-template>
      </div>
    }
  </div>
}

<ng-template #defaultListElementTemplate let-option="option">
  {{ option }}
</ng-template>
<ng-template #defaultTagTemplate let-option="option">
  {{ option }}
</ng-template>
